/**
 * InterestToggle Component
 * 
 * Switch to enable/disable interest calculation
 * Shows/hides interest fields based on toggle state
 */
import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Switch } from './ui/switch';
import { Label } from './ui/label';

const InterestToggle = ({ enabled, onChange, disabled = false, className = '' }) => {
  const { t } = useLanguage();

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <Switch
        id="interest-toggle"
        checked={enabled}
        onCheckedChange={onChange}
        disabled={disabled}
      />
      <Label
        htmlFor="interest-toggle"
        className="cursor-pointer"
      >
        {enabled ? t('interest.enabled') : t('interest.disabled')}
      </Label>
    </div>
  );
};

export default InterestToggle;
